module.exports = __webpack_public_path__ + "img/Build.7fd11fb8.png";